<router-outlet></router-outlet>

@if (!isProduction) {
	<cp-build-version [branch]="branch" [version]="version"></cp-build-version>
}